export const openChatWidget = () => {
    try {
        (window as any).$crisp.push(["do", "chat:show"]);
        (window as any).$crisp.push(["do", "chat:open"]);
    } catch (e) {
    }
};